"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Button = _interopRequireDefault(require("@airasia/phoenix-components/components/Button"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _calendar = require("../calendar.utilities");

var _calendarfooter = _interopRequireDefault(require("./calendarfooter.proptypes"));

var _constant = require("../constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var CalendarFooter = _styledComponents.default.div.withConfig({
  displayName: "calendarfooter__CalendarFooter",
  componentId: "sc-1pqsoxb-0"
})(["display:flex;flex-direction:row;background-color:", ";border-width:1px;border-color:", ";padding:", ";border-style:solid;border-top:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyMedium;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.small;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.none;
});

var FooterElements = _styledComponents.default.div.withConfig({
  displayName: "calendarfooter__FooterElements",
  componentId: "sc-1pqsoxb-1"
})(function (_ref5) {
  var justifyEnd = _ref5.justifyEnd;
  return "\n    display: flex;\n    flex: 1;\n\n    ".concat(justifyEnd ? "justify-content: flex-end;" : '', "\n  ");
});

var FooterLabel = _styledComponents.default.div.withConfig({
  displayName: "calendarfooter__FooterLabel",
  componentId: "sc-1pqsoxb-2"
})(function (_ref6) {
  var ismobile = _ref6.ismobile;
  return "\n    ".concat(ismobile ? "\n          position: relative;\n          top: -6px;\n        " : '', "\n  ");
});

var FooterButton = _styledComponents.default.div.withConfig({
  displayName: "calendarfooter__FooterButton",
  componentId: "sc-1pqsoxb-3"
})(function (_ref7) {
  var ismobile = _ref7.ismobile;
  return "\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n    align-items: center;\n    flex: 2;\n    justify-content: ".concat(ismobile ? 'center' : 'flex-start', ";\n\n    ").concat(ismobile ? "\n          flex-direction: column;\n        " : '', "\n  ");
});

var FooterButtonItem = _styledComponents.default.div.withConfig({
  displayName: "calendarfooter__FooterButtonItem",
  componentId: "sc-1pqsoxb-4"
})(["a{height:22px;}"]);

var AaCalendarFooter = function AaCalendarFooter(props) {
  var viewType = props.viewType,
      disableButtons = props.disableButtons,
      buttonsConfig = props.buttonsConfig,
      confirmLabel = props.confirmLabel,
      resetLabel = props.resetLabel,
      lowestFareLabel = props.lowestFareLabel,
      noFareLabel = props.noFareLabel,
      isFareLoaded = props.isFareLoaded,
      isFareLoadedV2 = props.isFareLoadedV2,
      currency = props.currency,
      theme = props.theme,
      onBlur = props.onBlur,
      isPartialHotelCalendar = props.isPartialHotelCalendar,
      lowestFareLabelOneWay = props.lowestFareLabelOneWay,
      lowestFareLabelDepart = props.lowestFareLabelDepart,
      lowestFareLabelReturn = props.lowestFareLabelReturn,
      tripType = props.tripType,
      selectForDepart = props.selectForDepart,
      selectForReturn = props.selectForReturn;
  var confirmBtnStyle = buttonsConfig.confirm.style || {
    backgroundColor: 'primary'
  };
  var customProperties = isPartialHotelCalendar ? {
    id: 'partialHotelClosebutton'
  } : {
    id: 'closebutton'
  };
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getLowestFareLabel = function getLowestFareLabel() {
    var label;

    if (isFareLoadedV2) {
      if (tripType === 'O') label = lowestFareLabelOneWay;

      if (tripType === 'R') {
        if (selectForDepart) label = lowestFareLabelDepart;
        if (selectForReturn) label = lowestFareLabelReturn;
      }
    } else label = lowestFareLabel;

    return _calendar.AaCalendarUtilities.formatString(label, [currency]);
  };

  var movePrimaryThemeButton = {
    true: {
      true: {
        backgroundColor: 'greyLight',
        border: 'greyMedium',
        color: 'greyMedium'
      },
      false: {
        backgroundColor: 'primary',
        border: 'secondary',
        color: 'secondary',
        hoverBackgroundColor: 'primaryDark',
        hoverColor: 'secondary'
      }
    },
    false: {
      false: _objectSpread({}, confirmBtnStyle)
    }
  };
  var moveSecondaryThemeButton = {
    true: {
      true: {
        backgroundColor: 'default',
        border: 'greyLight',
        color: 'greyLight'
      },
      false: {
        backgroundColor: 'default',
        border: 'secondary',
        color: 'secondary',
        hoverBackgroundColor: 'secondaryLight',
        hoverColor: 'secondary'
      }
    },
    false: {
      true: {
        border: 'greyLight'
      },
      false: {
        border: 'primary'
      }
    }
  };
  var isMoveTheme = theme === 'AIRASIA_MOVE' || (themeContext === null || themeContext === void 0 ? void 0 : themeContext.type) === 'AIRASIA_MOVE';
  return /*#__PURE__*/_react.default.createElement(CalendarFooter, null, /*#__PURE__*/_react.default.createElement(FooterButton, {
    id: isPartialHotelCalendar && 'partialHotelFooter' || 'footer',
    ismobile: viewType === _constant.MOBILE
  }, currency && /*#__PURE__*/_react.default.createElement(FooterElements, null, /*#__PURE__*/_react.default.createElement(FooterLabel, {
    ismobile: viewType === _constant.MOBILE
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "small",
    color: "greyDark",
    theme: theme
  }, isFareLoaded || isFareLoadedV2 ? getLowestFareLabel() : noFareLabel))), /*#__PURE__*/_react.default.createElement(FooterElements, {
    justifyEnd: true
  }, /*#__PURE__*/_react.default.createElement(FooterButtonItem, {
    style: {
      minHeight: 48,
      marginRight: 16
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, moveSecondaryThemeButton[isMoveTheme][disableButtons], {
    paddingLeft: "40px",
    paddingRight: "40px",
    handleClick: !disableButtons ? buttonsConfig.reset.controls.onButtonPress : null,
    disabled: disableButtons
  }), resetLabel)), /*#__PURE__*/_react.default.createElement(FooterButtonItem, {
    style: {
      minHeight: 48
    },
    onBlur: onBlur
  }, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    customProperties: customProperties,
    disabled: disableButtons,
    color: "default",
    paddingLeft: "40px",
    paddingRight: "40px",
    handleClick: !disableButtons ? buttonsConfig.confirm.controls.onButtonPress : null
  }, movePrimaryThemeButton[isMoveTheme][disableButtons]), confirmLabel)))));
};

AaCalendarFooter.propTypes = _calendarfooter.default.PropTypes;
AaCalendarFooter.defaultProps = _calendarfooter.default.DefaultProps;
var _default = AaCalendarFooter;
exports.default = _default;